var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"after-payment"}},[_vm._v("\n Twój link wygasł\n")])}
var staticRenderFns = []

export { render, staticRenderFns }